import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  IconButton,
  Divider,
  Box,
  Chip,
  Tooltip,
  useTheme,
  Avatar,
  Switch,
  Popover,
  IconButtonProps,
} from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import SettingsIcon from "@mui/icons-material/Settings";
import ProImg1 from "../../../../assets/images/AgentStar.svg";
import { MultiAgent } from "../../../Types/MultiAgent";
import { formatDate } from "../../../utils/Common/Common";
import { useNavigate } from "react-router-dom";
import variables from "../../../../assets/styles/variables.module.scss";
import {
  ChatBubbleOutlineOutlined,
  CodeOutlined,
  TroubleshootOutlined,
} from "@mui/icons-material";
import { TeamStatus } from "../../../Enum/MultiAgentEnum";
import { useDispatch } from "react-redux";
import { AGENT } from "../../../../Services/Endpoint";
import BaseInstance from "../../../../Services/AxiosInstance/BaseInstance";
import {
  StartLoading,
  StopLoading,
} from "../../../Store/LoadingReducer/LoaderActions";
import { Agent } from "../../../Types/Agent";
import { ShowError } from "../../../Store/MessageReducer/MsgActions";
import Embed from "../../../../Views/Components/Embed";
import calendarIcon from "../../../../assets/images/calendarIcon.svg";
//import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import CustomEmbedIcon from "../../../../assets/images/codeIcon.svg";

interface MyComponentProps {
  multiAgent: MultiAgent;
  deleteFunc: (multiAgent: MultiAgent) => void;
  editFun: (multiAgent: MultiAgent) => void;
  statusChangeFunc: (multiAgent: MultiAgent) => void;
}

const MultiAgentCard: React.FC<MyComponentProps> = React.memo(
  function MultiAgentCard(props) {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [agentIds, setAgentIds] = useState<string[]>([]);
    const [agents, setAgents] = useState<Agent[]>([]);
    const [openEmbed, setOpenEmbed] = useState(false);

    useEffect(() => {
      const sortedCurrent = [...agentIds].sort();
      const sortedIncoming = [...props.multiAgent.agent_ids].sort();

      const isEqual =
        sortedCurrent.length === sortedIncoming.length &&
        sortedCurrent.every((val, index) => val === sortedIncoming[index]);

      if (!isEqual) {
        setAgentIds(props.multiAgent.agent_ids);
        getAgents();
      }
    }, [props.multiAgent.agent_ids]);

    const getAgents = async () => {
      try {
        dispatch(StartLoading());
        const kwPromises = props.multiAgent.agent_ids.map((agentId) =>
          BaseInstance.get(`${AGENT}/${agentId}`).then((res) => res?.data)
        );
        const data = await Promise.all(kwPromises);
        setAgents(data);
      } catch (err: any) {
        dispatch(ShowError(err?.response?.data?.statusText));
      } finally {
        dispatch(StopLoading());
      }
    };

    const [agentAnchorEl, setAgentAnchorEl] = useState<HTMLElement | null>(
      null
    );
    const handleAgentPopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
      setAgentAnchorEl(event.currentTarget);
    };
    const handleAgentPopoverClose = () => {
      setAgentAnchorEl(null);
    };
    const agentPopoverOpen = Boolean(agentAnchorEl);

    const [toolAnchorEl, setToolAnchorEl] = useState<HTMLElement | null>(null);
    const toolOpen = Boolean(toolAnchorEl);
    const handleToolChipClick = (event: React.MouseEvent<HTMLElement>) => {
      if (agents.length > 0) setToolAnchorEl(event.currentTarget);
    };
    const handleToolPopoverClose = () => setToolAnchorEl(null);

    // Custom styled switch
    const ActiveSwitch = styled(Switch)(({ theme }) => ({
      width: 60,
      height: 20,
      padding: 0,
      display: "flex",
      "& .MuiSwitch-switchBase": {
        padding: 2,
        "&.Mui-checked": {
          transform: "translateX(39px)",
          color: "#fff",
          "& + .MuiSwitch-track": {
            backgroundColor: "#04db93",
            opacity: 1,
            border: 0,
          },
        },
      },
      "& .MuiSwitch-thumb": {
        boxShadow: "none",
        width: 16,
        height: 16,
        margin: 0,
      },
      "& .MuiSwitch-track": {
        borderRadius: 28 / 2,
        backgroundColor: "#64748B",
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
          duration: 500,
        }),
        position: "relative",
      },
    }));

    return (
      <Card
        sx={{
          borderRadius: "12px",
          backgroundColor: "rgba(256, 256, 256, 0.7)",
          height: "100%",
          boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
          backdropFilter: "blur(5px)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CardContent sx={{ p: 2 }}>
          <Box display="flex" alignItems="center" gap={1.5}>
            <Avatar
              src={ProImg1}
              sx={{
                backgroundColor: "#03C0D9",
                "& img": {
                  objectFit: "none",
                },
              }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                flexGrow: 1,
              }}
            >
              {props.multiAgent.name.length > 38 ? (
                <Tooltip title={props.multiAgent.name} placement="top-start">
                  <Typography
                    variant="subtitle1"
                    fontWeight={500}
                    noWrap
                    sx={{
                      maxWidth: 250,
                      lineHeight: "20px",
                      textTransform: "capitalize",
                    }}
                  >
                    {props.multiAgent.name}
                  </Typography>
                </Tooltip>
              ) : (
                <Typography
                  variant="subtitle1"
                  fontWeight={500}
                  noWrap
                  sx={{
                    maxWidth: 250,
                    lineHeight: "20px",
                    textTransform: "capitalize",
                  }}
                >
                  {props.multiAgent.name}
                </Typography>
              )}
              {/* <Typography
                variant="subtitle1"
                fontWeight={500}
                noWrap
                sx={{
                  maxWidth: 250,
                  lineHeight: "20px",
                  textTransform: "capitalize",
                }}
              >
                {props.multiAgent.name}
              </Typography> */}
              <Typography
                variant="caption"
                noWrap
                sx={{
                  maxWidth: 250,
                  color: "#6E6E6E",
                  textTransform: "capitalize",
                }}
              >
                {props.multiAgent.model && props.multiAgent.model.includes(":")
                  ? props.multiAgent.model.split(":")[1]
                  : props.multiAgent.model || ""}
              </Typography>
            </Box>
          </Box>
          {props.multiAgent.description.length > 52 ? (
            <Tooltip title={props.multiAgent.description} placement="top-start">
              <Typography
                variant="body1"
                color="text.secondary"
                mt={1}
                sx={{
                  display: "-webkit-box",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical",
                  minHeight: "22px",
                }}
              >
                {props.multiAgent.description}
              </Typography>
            </Tooltip>
          ) : (
            <Typography
              variant="body1"
              color="text.secondary"
              mt={1}
              sx={{
                display: "-webkit-box",
                overflow: "hidden",
                textOverflow: "ellipsis",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
                minHeight: "22px",
              }}
            >
              {props.multiAgent.description}
            </Typography>
          )}

          <Box display="flex" alignItems="center" gap={1} mt={1}>
            <Box display="flex">
              <img src={calendarIcon} />
            </Box>
            <Typography variant="body2" sx={{ color: "#6E6E6E" }}>
              {props.multiAgent.created_at
                ? formatDate(props.multiAgent.created_at)
                : ""}
            </Typography>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mt={1.3}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mr: 0.5 }}
              >
                Agents:
              </Typography>
              <Chip
                size="small"
                label={
                  props.multiAgent.agent_ids.length > 0
                    ? `${props.multiAgent.agent_ids.length} active`
                    : "Not selected"
                }
                onClick={handleToolChipClick}
                sx={{
                  backgroundColor:
                    props.multiAgent.agent_ids.length > 0
                      ? "#f5f7fa"
                      : "#FFF8E1",
                  color:
                    props.multiAgent.agent_ids.length > 0 ? "#222" : "#FFA000",
                  fontSize: "12px",
                  fontWeight: 400,
                  textTransform: "capitalize",
                  borderRadius: "16px",
                  cursor:
                    props.multiAgent.agent_ids.length > 0
                      ? "pointer"
                      : "default",
                  "& .MuiChip-icon": {
                    marginLeft: "4px",
                  },
                }}
                clickable={props.multiAgent.agent_ids.length > 0}
              />
              <Popover
                open={toolOpen}
                anchorEl={toolAnchorEl}
                onClose={handleToolPopoverClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <Box
                  sx={{
                    p: 1,
                    minWidth: 180,
                    display: "flex",
                    gap: 1,
                    flexDirection: "column",
                    maxHeight: "97px",
                    overflowY: "auto",
                  }}
                >
                  {agents.map((tool, idx) => (
                    <Chip
                      key={tool.id || idx}
                      label={tool.name}
                      variant="outlined"
                      size="small"
                      sx={{ textTransform: "capitalize" }}
                    />
                  ))}
                </Box>
              </Popover>
            </Box>
            {props.multiAgent.user_permission && (
              <Tooltip title="MultiAgent status">
                <Box sx={{ position: "relative", display: "inline-block" }}>
                  <ActiveSwitch
                    disabled={props.multiAgent.user_permission === "read"}
                    checked={props.multiAgent.status === TeamStatus.ACTIVE}
                    onChange={() => props.statusChangeFunc(props.multiAgent)}
                    size="small"
                    inputProps={{ "aria-label": "toggle-button" }}
                  />
                  <Typography
                    variant="caption"
                    sx={{
                      position: "absolute",
                      left:
                        props.multiAgent.status === TeamStatus.ACTIVE ? 12 : 22,
                      top: "50%",
                      transform: "translateY(-50%)",
                      color:
                        props.multiAgent.status === TeamStatus.ACTIVE
                          ? "#fff"
                          : "#fff",
                      fontWeight: 600,
                      fontSize: 9,
                      pointerEvents: "none",
                      userSelect: "none",
                      transition: "left 0.2s",
                    }}
                  >
                    {props.multiAgent.status === TeamStatus.ACTIVE
                      ? "Active"
                      : props.multiAgent.status === TeamStatus.PAUSED
                      ? "Paused"
                      : "Stopped"}
                  </Typography>
                </Box>
              </Tooltip>
            )}
          </Box>

          {/* <Box display="flex" flexDirection="column" gap={1}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="body2" fontWeight={600}>
                Status:
              </Typography>
              <Chip
                label={props.multiAgent.status}
                color={
                  props.multiAgent.status === TeamStatus.ACTIVE
                    ? "success"
                    : props.multiAgent.status === TeamStatus.PAUSED
                    ? "warning"
                    : "error"
                }
                size="small"
              />
            </Box>
          </Box> */}

          {/* Agents List */}
          {/* {props.multiAgent.agent_ids.length > 0 && (
            <>
              <Typography variant="subtitle2" fontWeight={600} mt={1}>
                Agents
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                {agents.slice(0, 5).map((agent, index) => (
                  <Chip
                    label={agent.name}
                    key={index}
                    variant="outlined"
                    size="small"
                    sx={{ m: 0.5 }}
                  />
                ))}
                {agents.length > 5 && (
                  <>
                    <Chip
                      label={`+${agents.length - 5}`}
                      variant="outlined"
                      size="small"
                      onClick={handleAgentPopoverOpen}
                      sx={{ cursor: "pointer", m: 0.5 }}
                    />
                    <Popover
                      open={agentPopoverOpen}
                      anchorEl={agentAnchorEl}
                      onClose={handleAgentPopoverClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                    >
                      <Box
                        sx={{
                          p: 1,
                          display: "flex",
                          flexWrap: "wrap",
                          maxWidth: "300px",
                        }}
                      >
                        {agents.slice(5).map((agent, index) => (
                          <Chip
                            label={agent.name}
                            key={index}
                            variant="outlined"
                            size="small"
                            sx={{ m: 0.5 }}
                          />
                        ))}
                      </Box>
                    </Popover>
                  </>
                )}
              </Box>
            </>
          )} */}

          {/* --------Instructions removed as per new design-------- */}
          {/* <Typography variant="subtitle2" fontWeight={600} mt={1}>
            Instructions
          </Typography>
          <Tooltip title={props.multiAgent.instructions} placement="top-start">
            <Typography
              variant="body1"
              color="text.secondary"
              mt={0.5}
              sx={{
                display: "-webkit-box",
                overflow: "hidden",
                textOverflow: "ellipsis",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
                minHeight: "27px",
                // mb: 2,
              }}
            >
              {props.multiAgent.instructions} instructions configured
            </Typography>
          </Tooltip> */}
        </CardContent>

        <Box sx={{ mt: "auto" }}>
          <Divider />
          <CardActions
            sx={{
              display: "flex",
              justifyContent: "space-between",
              px: 2,
              py: 1,
            }}
          >
            <Box display="flex" alignItems="center" gap={1.5}>
              {props.multiAgent.agent_ids.length === 0 ? (
                <Box display="flex" alignItems="center" gap={0.5}>
                  <Box
                    sx={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      backgroundColor: "error.main",
                    }}
                  ></Box>
                  <Typography variant="caption" color="error">
                    Setup Incomplete
                  </Typography>
                </Box>
              ) : (
                <Box display="flex" alignItems="center" gap={0.5}>
                  <Box
                    sx={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      backgroundColor: "#04db93",
                    }}
                  ></Box>
                  <Typography variant="caption" color="#04db93">
                    Ready To Use
                  </Typography>
                </Box>
              )}
            </Box>
            <Box display="flex">
              <Tooltip title="Chat with Agent">
                <IconButton
                  aria-label="run-agent"
                  onClick={() =>
                    navigate(`/playground/teams/${props.multiAgent.id}`)
                  }
                  disabled={
                    props.multiAgent.status === TeamStatus.PAUSED || // if status is paused
                    props.multiAgent.status === TeamStatus.STOPPED // if status is stopped 
                  }
                >
                  <ChatBubbleOutlineOutlined fontSize="small" />
                </IconButton>
              </Tooltip>
              {props.multiAgent.user_permission && (
                <Tooltip title="Settings">
                  <IconButton
                    disabled={
                      props.multiAgent.user_permission === "read" ? true : false
                    }
                    onClick={() => props.editFun(props.multiAgent)}
                    sx={{
                      padding: "6px",
                      backgroundColor: "white",
                      "&:hover": { backgroundColor: "#f0f0f0" },
                    }}
                    aria-label="settings"
                  >
                    <SettingsIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}

              {props.multiAgent.user_permission && (
                <Tooltip title="Embed">
                  <IconButton
                    onClick={() => setOpenEmbed(true)}
                    disabled={
                      props.multiAgent.user_permission === "read" ||
                      props.multiAgent.agent_ids.length === 0 ||
                      props.multiAgent.status === TeamStatus.PAUSED ||
                      props.multiAgent.status === TeamStatus.STOPPED
                        ? true
                        : false
                    }
                    sx={{
                      width: "36px",
                      opacity:
                        props.multiAgent.user_permission === "read" ||
                        props.multiAgent.agent_ids.length === 0 ||
                        props.multiAgent.status === TeamStatus.PAUSED ||
                        props.multiAgent.status === TeamStatus.STOPPED
                          ? 0.5
                          : 1,
                    }}
                  >
                    <img src={CustomEmbedIcon} alt="Embed" />
                  </IconButton>
                </Tooltip>
              )}

              {props.multiAgent.user_permission && (
                <Tooltip title="Delete Agent">
                  <IconButton
                    aria-label="delete-agent"
                    onClick={() => props.deleteFunc(props.multiAgent)}
                    disabled={
                      props.multiAgent.user_permission === "read" ? true : false
                    }
                  >
                    <DeleteOutlineOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </CardActions>
        </Box>
        {/* embed drawer */}
        {openEmbed && props.multiAgent.id && (
          <Embed
            setOpenEmbed={setOpenEmbed}
            openEmbed={openEmbed}
            multiAgentId={props.multiAgent.id}
          />
        )}
      </Card>
    );
  }
);

export default MultiAgentCard;
